module.exports = __webpack_public_path__ + "static/media/varal-magico.d855ce82.jpg";